import { render, staticRenderFns } from "./InputFormaPago.vue?vue&type=template&id=5778eab0&scoped=true&"
import script from "./InputFormaPago.vue?vue&type=script&lang=js&"
export * from "./InputFormaPago.vue?vue&type=script&lang=js&"
import style0 from "./InputFormaPago.vue?vue&type=style&index=0&id=5778eab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5778eab0",
  null
  
)

export default component.exports